export const canCaptureComplication = () => (app.acl.is_nurse || app.acl.is_doc_presc || app.acl.is_NP || app.acl.is_doc_gp) && !app.acl.is_admin;
